

import { getToken, setToken, removeToken ,getLocalStorage,saveLocalStorage,clearLocalStorage} from '@/utils/auth'
import {updateCompanyInfo,updatePwdByOldPwd, updateRealName,accountLogin,accountLogout,updatePwdAccount ,updateSecurityMobile} from '@/zsm-api-new/login.js'
import { getByMobileAndPlatform,getEnroll,updateFront ,getFront} from '@/zsm-api-new/user.js'

const state = {
  // getLocalStorage('platformDict').replace(/\"/g,'')||
  loginUserInfo:getLocalStorage('loginUserInfo')||'',//密报手机号
  securityMobile:getLocalStorage('securityMobile')||'',//密报手机号
  platformDict: 'douyin', // 平台
  // userList:JSON.parse(getLocalStorage.getItem('userList'))||[],//当前手机号下的所有用户
  userInfo:getLocalStorage('zsm-userInfo')||'',//当前选中平台下的用户
  // JSON.parse(JSON.parse())
  mobile: getLocalStorage('zsm-mobile')||'',//手机号
  token: getToken('zsm-token')
}

const mutations = {
  // 设置用户基本信息
  SET_LOGIN_USER_INFO: (state, info) => {
    saveLocalStorage('loginUserInfo', JSON.stringify(info));
	state.loginUserInfo=getLocalStorage('loginUserInfo')
  },
  // 设置平台
  SET_PLATFORM_DICT: (state, platformDict) => {
    /* state.platformDict=platformDict
     saveLocalStorage('platformDict', platformDict); */
  },
  // 设置手机号
  SET_NEW_MOBILE: (state, securityMobile) => {
     state.securityMobile=securityMobile
     saveLocalStorage('securityMobile', securityMobile);
  },
  // 设置手机号
  SET_MOBILE: (state, mobile) => {
    console.log(mobile)
    if(mobile==''){
      state.mobile=''
      return  false
    }
    state.mobile = mobile
    saveLocalStorage('zsm-mobile', mobile);
  },
  // 设置token
  SET_TOKEN: (state, token) => {
    if(token==''){
      state.token=''
      return  false
    }
    setToken('zsm-token', token)
  },
  // 所有平台下的用户列表
/*  SET_USER_LIST: (state, list) => {
    if(list==''){
      state.list=[]
      return  false
    }
    state.userList = list
    sessionStorage.setItem('userList', JSON.stringify(list));
  }, */
  // 当前平台下用户基本信息
  SET_USER_INFO: (state, info) => {
   // state.userInfo = info
    saveLocalStorage('zsm-userInfo', JSON.stringify(info));
    // state.userInfo=JSON.stringify(info)
    state.userInfo =getLocalStorage('zsm-userInfo')
    // console.log(state.userInfo)
  }
}

const actions = {
  //通过手机哈获取前端用户
  getByMobileAndPlatform({ commit }, info) {
    return new Promise((resolve, reject) => {
      getByMobileAndPlatform(info).then(response => {
        if(response.result=='true'){
          commit('SET_USER_INFO', response.data)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user reset Pwd
    updatePwdAccount({ commit },info) {
      console.log(info)
      return new Promise((resolve, reject) => {
        updatePwdAccount(info).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
// user logout
  accountLogout({ commit },id) {
    console.log(id)
    return new Promise((resolve, reject) => {
      accountLogout(id).then((response) => {
        clearLocalStorage()
        sessionStorage.clear();
        removeToken()
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  accountLogin({ commit }, loginInfo) {
    return new Promise((resolve, reject) => {

      accountLogin(loginInfo).then(response => {
		  if(response.result=='true'){
			  commit('SET_MOBILE', loginInfo.id)
			  commit('SET_NEW_MOBILE', response.data.securityMobile)
			  commit('SET_TOKEN', response.data.token)
			  saveLocalStorage('zsm-login', true)
			  saveLocalStorage('zsm-versions', '1.0.1');
			  commit('SET_PLATFORM_DICT', 'douyin')
			  commit('SET_LOGIN_USER_INFO', response.data)
		  }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

// 获取用户信息
  getFront({ commit }, id) {
    return new Promise((resolve, reject) => {
      getFront(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改用户信息
  updateFront({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateFront(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取用户入驻信息
  getEnroll({ commit }, id) {
    return new Promise((resolve, reject) => {
      getEnroll(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户入驻信息
  updateSecurityMobile({ commit }, info) {
    let {code,id,newMobile} =info
    return new Promise((resolve, reject) => {
      updateSecurityMobile(code,id,newMobile).then(response => {
        if(response.result=='true'){
          console.log(newMobile)
          commit('SET_NEW_MOBILE',newMobile)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改密码-根据老密码修改密码
  updatePwdByOldPwd({ commit }, info) {
    let { id,oldPwd,newPwd} =info
    return new Promise((resolve, reject) => {
      updatePwdByOldPwd( id,oldPwd,newPwd).then(response => {
        if(response.result=='true'){
          console.log(newPwd)
          commit('SET_NEW_MOBILE',newPwd)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 修改资料-个人的真实姓名
  updateRealName({ commit }, info) {
    let {  id,realName} =info
    return new Promise((resolve, reject) => {
      updateRealName(  id,realName).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 修改资料-个人的真实姓名
  updateCompanyInfo({ commit }, info) {
    return new Promise((resolve, reject) => {
      let {  id,companyCode,companyName} =info
      updateCompanyInfo(  id,companyCode,companyName).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
